import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { apiconstants } from '../constants/api.constant';
import { IResponse } from '../models/response';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private _http: HttpClient) { }

  getAllContacts(projectId): Observable<any> {
    return this._http.get(apiconstants.ENDPOINT + 'project/' + projectId + '/' + apiconstants.API_GET_CONTACTS).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  saveContact(projectId, params) {
    return this._http.post(apiconstants.ENDPOINT + 'contact', params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  updateContact(contactId, params) {
    return this._http.put(apiconstants.ENDPOINT + 'contact/' + contactId, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  deleteContact(contactId) {
    return this._http.delete(apiconstants.ENDPOINT + 'contact' + '/' +contactId).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getAllContactTypes(): Observable<any> {
    return this._http.get(apiconstants.API_GET_CONTACT_TYPES).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

}
